module.exports = __webpack_public_path__ + "static/media/unselect-circular.1d1bb816.svg";